import React from "react";

type Props = {
  width: number;
  height: number;
  variant?: "filled" | "outline";
};

const Microsoft = ({ width, height, variant = "filled" }: Props) => {
  if (variant === "outline") {
    const cellSize = 6;
    const gap = 4;
    const inset = 2;
    const squareProps = {
      width: cellSize,
      height: cellSize,
      rx: 1.5,
      stroke: "currentColor",
      strokeWidth: 1.9,
      strokeLinejoin: "round" as const,
    };
    const top = inset;
    const left = inset;
    const right = inset + cellSize + gap;
    const bottom = inset + cellSize + gap;

    return (
      <svg width={width} height={height} viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <rect x={left} y={top} {...squareProps} />
        <rect x={right} y={top} {...squareProps} />
        <rect x={left} y={bottom} {...squareProps} />
        <rect x={right} y={bottom} {...squareProps} />
      </svg>
    );
  }

  return (
    <svg width={width} height={height} viewBox="0 0 64 63" fill="none" aria-hidden="true">
      <path fill="#fff" d="M0 0h30v30H0zM34 0h30v30H34zM0 33h30v30H0zM34 33h30v30H34z" />
    </svg>
  );
};

export default Microsoft;
